import moment from 'moment';

import { DATE_FORMAT } from '@constants/common/date.constants';

export const formatDateTime = (
  value: string,
  format = DATE_FORMAT.DOT_MONTH_DATE_YEAR,
): string => moment(value).format(format);

export const fromNow = (value: Date) => moment(value).fromNow();
